/* eslint-disable */
import { SkeletonWrapper } from '@/components/SkeletonWrapper';
import { Box } from '@mui/material';
import {
  Badge,
  CardContent,
  CardTitle,
  ContentLabel,
  ContentValue,
} from './styles';

export type CardData = {
  label: string;
  value: string | number | boolean;
  user_status?: 'active' | 'inactive';
};

interface CardProps {
  title?: string;
  cardData: CardData[];
  qtdItems?: number;
  isLoading: boolean;
}

export function Card({
  title,
  cardData,
  qtdItems,
  isLoading,
}: CardProps): JSX.Element {
  const itemsLenght = qtdItems || 6;
  return (
    <Box sx={{ width: '100%' }}>
      <CardTitle>{title}</CardTitle>
      <CardContent>
        {!isLoading
          ? cardData?.map((data) => (
              <div key={data.label} className="card-data">
                <ContentLabel>{data.label}</ContentLabel>
                <ContentValue>
                  {data.user_status && <Badge status={data.user_status} />}
                  {data.user_status
                    ? data.user_status === 'active'
                      ? 'Ativo'
                      : 'Inativo'
                    : data.value}
                </ContentValue>
              </div>
            ))
          : Array.from({ length: itemsLenght }).map((_, index) => (
              <div className="card-data">
                <SkeletonWrapper
                  key={index}
                  isLoading={isLoading}
                  variant="rectangular"
                  height={16}
                  width={64}
                />
                <SkeletonWrapper
                  key={index}
                  isLoading={isLoading}
                  variant="rectangular"
                  height={16}
                  width={128}
                />
              </div>
            ))}
      </CardContent>
    </Box>
  );
}
